// reducer.js
interface IndicatorPackage {
  id: number;
  created_at: string;
  updated_at: string;
  created_by_id: null | number;
  updated_by_id: null | number;
  name: string;
  code: null | string;
  type: string;
}

export type indicatorDataType = "Ratio" | "Number" | "Percentage" | "Scale" | "";
export interface Indicator {
  id: number;
  created_at: string;
  updated_at: string;
  created_by_id: null;
  updated_by_id: null;
  name: string;
  code: null;
  definition: string;
  purpose: string;
  interpretation: string;
  calculation_method: string;
  type: string;
  unit_of_measurement: string;
  frequency_of_measurement: string;
  disaggregation: string;
  performance_target: null | number;
  data_source: string;
  data_type: indicatorDataType;
  limitations: string;
  department_id: null | number;
  technical_notes: string;
  phase: string;
  project_id: null | number;
  indicator_package_id: number;
  indicator_package: IndicatorPackage;
  departments: [];
}

export interface IndicatorState {
  data: Indicator[];
  error: string | null;
}

export interface Action {
  type: string;
  payload: any;
}

const indicatorinitialState: IndicatorState = {
  data: [],
  error: null,
};

export const indicatorReducer = (
  state: IndicatorState = indicatorinitialState,
  action: Action
): IndicatorState => {
  switch (action.type) {
    case "FETCH_INDICATORS_SUCCESS":
      return { ...state, data: action.payload };
    case "FETCH_INDICATORS_ERROR":
      return { ...state, error: action.payload };
    default:
      return state;
  }
};
